$(document).ready(function(){

  function addPromo(free_product_id,items){

    let _free_gift_flag = true;
    $.each(items,function(key,item){
      console.log(item.id , free_product_id, item.properties);
      if(item.id == free_product_id && item.properties['_free_gift']){
        _free_gift_flag = false;
        return false;
      }
    });
    console.log("_free_gift_flag = "+_free_gift_flag);
    if(_free_gift_flag == false){ return false; }
    
    $.ajax({
      url: "/cart/add.js",
      dataType: 'json',
      data: {
        'id': free_product_id, 
        'quantity': 1,
        'properties': { "_free_gift": "true"}
      }
    }).done(function(cart) {
      //alert('Add');

      if(window.location.pathname=='/cart'){
        window.location.reload();
      }
      
      if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
        Shopify.theme.jsAjaxCart.updateView();
      }else{
        window.location.reload();
      }
      
    });
  }

  function reCalculatePromo(type='qty',items,inclusions="",exclusions=""){

    let total = 0;
    $.each(items,function(key,item){
      
      if(typeof item.properties['_free_gift']=="undefined"){
          
        let allow_count = false;
        //console.log(inclusions, item.tags);
        // let result;
        // Logic
        if(inclusions.includes(',')){
            let split = inclusions.split(',')
            console.log('split', split)
            for(let i =0; i < split.length; i++){
                if(!item.tags.includes(split[i].trim())){
                    allow_count = false
                    break;
                } else {
                    allow_count = true
                }
            }
        } else {
            allow_count = item.tags.includes(inclusions)
        }
        // console.log('result', allow_count)
        // if(inclusions=="" || (inclusions!="" && item.tags.indexOf(inclusions) > -1) ){
        //   allow_count = true;
        // }

        // if(exclusions!="" && item.tags.indexOf(exclusions) > -1 ){
        //   allow_count = false;
        // }

        if(allow_count){
          if(type=="buy_NUM_get_X"){
            total += item.quantity;  
          }else{
            total += (item.line_price/100);
          }
        }
        
      }
    });

    return total;
    
  }
  
  function removePromo(free_product_id,items){
  
    $.each(items,function(key,item){
      if(item.id == free_product_id && item.properties['_free_gift']){
         $.ajax({
          url: "/cart/change.js",
          dataType: 'json',
          data: {
            'id': free_product_id, 
            'quantity': 0,
          }
        }).done(function(cart) {
           //alert('Add');

            if(window.location.pathname=='/cart'){
              window.location.reload();
            }
            
            if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
              Shopify.theme.jsAjaxCart.updateView();
            }else{
              window.location.reload();
            }
        });
      }
    });
  
  }

  function getFreeProduct(){
    
  }

  function notification(setting,quantity){

    let min = setting.min_threshold || 0;
    
    if(quantity>=min){ return false };
    
    let css = JSON.parse($('[data-promotion-section-settings]').html());
    let wrap = $('.promotional-section');
    let background_color = css.background_color;
    let gradient_color_1 = css.gradient_color_1;
    let gradient_color_2 = css.gradient_color_2;
    let text_color = css.text_color;
    let left = (min>=quantity)?(min - quantity):min;
    let text = '';
    let html = '';
    if(setting.promotion_type == 'buy_NUM_get_X'){
        text = setting.cart_message.replace('%amount%',Math.round(left));
    }
    else
    {
        text = setting.cart_message.replace('%amount%',left.toFixed(0));
    }
    let progress = 100 - ((left*100)/min);
     if(setting.cart_message == '')
    {
      html = '';
    }
    else
     {
     html = `<div class="cart-page__promo-messages" data-promotion-container="" style="--promotion-background-color:${background_color}; --promotion-text-color:${text_color};"> 
                	<h2 class="cart-page__promo-message-text" data-promotion-message="" style="--promotion-text-color:${text_color};">${text}</h2> 
                	<div class="cart-page__promo-message-progress" data-promotion-progress="" style="display:none; --percentage-complete:${progress}%; --promotion-progress-color-one:${gradient_color_1}; --promotion-progress-color-two:${gradient_color_2};">
                	</div>
                </div>`;
     // $('.promotional-section').append(html)
     }
    wrap.append(html);
  }

  function promotionAjax(){
    
    $.ajax({
      url: "/cart?view=promotional",
      dataType: 'html'
    }).done(function(cart) {
      // console.log('clear')
      $('.promotional-section').html('');
      cart = JSON.parse(cart);

      if(cart.items.length==0){return false};
      
      var promotion_settings = JSON.parse($('[data-promotion-settings]').html());
      var promotion_products = JSON.parse($('[data-promotion-products]').html());
      
      $.each(promotion_settings,function(index,setting){
                  
        let min_threshold = setting.min_threshold || 0;
        //let max_threshold = setting.max_threshold || 0;
        
        // Check and Add Promo Product
        var total_quantity = reCalculatePromo(setting.promotion_type,cart.items,setting.inclusions,setting.exclusions);
    
        let free_product_id = promotion_products[index].available_variant;
        let tag = promotion_products[index].tag;
        console.log("total_quantity"+total_quantity,"min_threshold==="+ min_threshold);
 
        notification(setting,total_quantity);
        
        if(total_quantity >= min_threshold){
          
          addPromo(free_product_id,cart.items);
        }else{
          removePromo(free_product_id,cart.items)
        }    
      });
    });
  }

  function promotionInit(){
    $('#template-cart [action="/cart"], .ajax-cart__list').before('<div class="promotional-section promotional_section"></div>');
  }
  
  $( document ).ajaxComplete(function( event, xhr, settings ) {
    if(settings.url.indexOf('/cart?view=ajax')>-1){
      promotionAjax();
    }
  });

  $(function(){

    let delay = 0;
    if($('#template-cart').length == 0 && typeof Shopify.theme.jsAjaxCart != 'undefined'){
      delay = 5000;
    }

    setTimeout(function(){
      promotionInit();
      promotionAjax();
    },delay);
    
  });
  
    
});


